import { useDispatch, useSelector } from 'react-redux';
import { MAPPING_FILTERS_CONFIG_KEY } from 'constants/auto-mapping';
import { store } from 'redux-rest-reducer';
import { useEffect } from 'react';
import { get as getConfig } from 'actions/configs';

const useLogic = ({ filters }) => {
  const configs = useSelector(({ configs }) => configs);
  const dispatch = useDispatch();
  const { filters: mappingFilters } =
    store.get(configs, MAPPING_FILTERS_CONFIG_KEY)?.data ?? {};

  useEffect(() => {
    dispatch(getConfig?.(MAPPING_FILTERS_CONFIG_KEY));
  }, [dispatch]);

  const isDisabled = mappingFilters?.some(el => el?.is_required && !filters?.[el?.code]);

  return {
    mappingFilters,
    isDisabled,
  };
};

export default useLogic;
